import React, { useState, useEffect } from "react";
import {
    CalloutCard,
    Page,
    Banner,
    Frame,
    Modal,
    Card,
    TextContainer,
    TextStyle,
    Button, Heading, Link
} from "@shopify/polaris";
import Main_Page from "../Main_Page";
import { useDispatch, useSelector } from "react-redux";
import preview from "../Images/preview.png";
import logo from "../Images/appearance.png";
import { withRouter, useHistory } from "react-router-dom";
import { NotificationMajor } from "@shopify/polaris-icons";
import Customisemsg from "./customisemsg";
import $ from 'jquery';
import * as authService from "../../services/authService";
import userData from "../../staticenv";
import Footer from "../footer";
import { SHOP_PLAN } from "../Account/index";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();
    const status_change = useSelector(
        (state) => state.allReducer.status_change
    );
    const [loadingFlagAdvance, setLoadingFlagAdvance] = useState(false);
    const shop_plan = useSelector((state) => state.allReducer.shop_plan);
    const [loadingOrderLink, setLoadingOrderLink] = useState(false);
    const [modalOrderLink, setModalOrderLink] = useState(false);
    const [loadingFlag, setLoadingFlag] = useState(false);
    const [getEnv, setGetEnv] = useState("");

    const buyNowHandle = () => {
        setLoadingFlagAdvance(true);
        authService
            .premiumPlan()
            .then((response) => {
                if (response && response.status === 200) {
                    window.parent.location.replace(
                        response.data.data.redirect_url
                    );
                }
            })
            .catch((error) => {
                setLoadingFlagAdvance(false);

                console.log(error);
            });
    };

    useEffect(() => {
        setLoadingFlag(true);

        authService
            .getEnv()
            .then((res) => {
                if (res && res.data && res.data.data && res.data.data.data) {
                    setGetEnv(res.data.data.data);
                }
            })
            .catch((error) => {
                setLoadingFlag(false);
            });
    }, []);

    useEffect(() => {
        authService
            .planDetail()
            .then((response) => {
                dispatch({
                    type: SHOP_PLAN,
                    data: { ...response, loading: false },
                });
            })
            .catch((error) => {
                console.log("error", error);
            });
    }, []);

    const handlePreviewPage = () => {
        // setRoute("/preview");
        // $(".sc-Axmtr").click()
        // window.location.href = "javascript:$zopim.livechat.window.hide();";
        setLoadingOrderLink(true);
        authService
            .previewOrderLink()
            .then((response) => {
                setLoadingOrderLink(false);
                if (response && response.data && response.data.data) {
                    window.open(response.data.data, "_blank");
                } else {
                    setModalOrderLink(true);
                }
            })
            .catch((error) => {
                setLoadingOrderLink(false);
                console.log(error);
            });
    };
    const handleDeleteClose = () => {
        setModalOrderLink(false);
    };
    return (
        <div>
            <Main_Page />
            <Page
                breadcrumbs={[{ content: "Dashboard", url: "/" }]}
                title="Appearance"
            >
                <Frame>
                    <div className="callout-image">
                        <CalloutCard
                            title="Preview Your Activation/Password Message"
                            illustration={logo}
                            primaryAction={{
                                content: "Preview",
                                onAction: () => {
                                    status_change && status_change.status
                                        ? handlePreviewPage()
                                        : setModalOrderLink(true);
                                    // history.push("/preview");
                                },
                            }}
                        >
                            <p>
                                Below you can update your activation message
                                with a custom heading, text, images and password
                                form style.
                            </p>
                        </CalloutCard>
                    </div>
                    <br />
                    {/* {shop_plan && shop_plan.plan === "basic" && (
                        <Banner
                            title="Settings are only configurable for upgraded plans"
                            status="warning"
                            action={{
                                content: "Upgrade",
                                onAction: () => {
                                    history.push("/account");
                                },
                            }}
                            icon={NotificationMajor}
                        >
                            <p>
                                Basic plans can only use the default settings.
                                Upgrade to customize your message or add
                                conditional logic
                            </p>
                        </Banner>

                    )} */}

                    <br />

                    {shop_plan && shop_plan.plan === "basic" && (
                        <Card sectioned>
                            <Heading>
                                Your Free Plan Has Limitations
                            </Heading>
                            <br />
                            <TextStyle>
                                Basic plans can only use the default settings. Upgrade to customize your message or add
                                conditional logic
                            </TextStyle>
                            <br />
                            <br />
                            <Button primary loading={loadingFlagAdvance}
                                onClick={() => { buyNowHandle() }}
                            >
                                Start your subscription for ${getEnv}/month
                            </Button>
                        </Card>
                    )}
                    <br />
                    <br />
                    <Customisemsg />
                    <Modal
                        open={modalOrderLink}
                        onClose={handleDeleteClose}
                        title="Preview Activation Message"
                        secondaryActions={[
                            {
                                content: "Close",
                                onAction: handleDeleteClose,
                            },
                        ]}
                    >
                        <Modal.Section>
                            {status_change && status_change.status ? (
                                <TextContainer>
                                    <p>
                                        To preview your activation message go to one of your <Link onClick={() => {
                                            window.open(`https://${userData.shop}/admin/orders`);
                                        }}> recent orders</Link>,
                                        and select 'More Actions' located at the top right, and from the dropdown choose
                                        'View order status page'.
                                    </p>
                                    <br />
                                    <img style={{ width: "180px" }} src={preview}></img>
                                    <br />

                                    <p>Make sure you choose an order from a customer that has yet to create an account, as the message does not show for already created accounts.
                                    </p>
                                </TextContainer>
                            ) : (
                                <TextContainer>
                                    <p>Please enable the app first. </p>
                                </TextContainer>
                            )}
                        </Modal.Section>
                    </Modal>
                </Frame>
                <Footer />
            </Page>
        </div>
    );
}
